var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sortValue === _vm.sortBy)?_c('span',[(_vm.sortDir === 'ASC')?_c('i',{staticClass:"fa fa-caret-up"}):_vm._e(),_vm._v(" "),(_vm.sortDir === 'DESC')?_c('i',{staticClass:"fa fa-caret-down"}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }